var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-table',{attrs:{"url":"accounters-report/internal-transfers","title":"انتقال وجه داخلی","fields":_vm.fields,"params":_vm.params,"excelroute":'asdasd'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }